<!-- GRAPH -->
@if (loadingModel.isLoading) {
  <span class="ui-loading" [model]="loadingModel"></span>
} @else {
  <div class="station-dashboard-graph">
    <!-- TITLE -->
    <div class="station-dashboard-graph-header">
      <p class="station-dashboard-graph-title">{{ Ititle | translate}}</p>
    </div>
    <div class="station-dashboard-graph-body">
      <!-- body -->
      <!-- MENU -->
      <div class="cubejs-actions">
        @if (userWantsCustomDateRange) {
          <div class="cubejs-form-block row">
            <!-- START DATE -->
            <div class="form-group start-date">
              <dp-date-picker
                [(ngModel)]="startDateFilter"
                [config]="startDatePickerConfig"
                mode="day"
                required
                (onChange)="onChangeCustomDate($event)">
              </dp-date-picker>
            </div>
            <!-- END DATE -->
            <div class="form-group end-date">
              <dp-date-picker
                [(ngModel)]="endDateFilter"
                [config]="endDatePickerConfig"
                mode="day"
                required
                (onChange)="onChangeCustomDate($event)">
              </dp-date-picker>
              @if (!isValidDateRange) {
                <div class="alert alert-danger">
                  {{'error.endDateBeforeStartDate' | translate}}
                </div>
              }
            </div>
          </div>
        }
        <!-- DATE RANGE -->
        <div class="cubejs-form-block">
          <span class="cubejs-form-block-label">{{'timeGroup.for' | translate}}</span>
          <mat-form-field appearance="fill" class="cubejs-dropdown">
            <mat-select [(value)]="currentDateRange" (selectionChange)="onChangeDateRange($event.value)">
              @for (dateRange of dateRangeList; track dateRange) {
                <mat-option [value]="dateRange.value">
                  {{dateRange.name | translate}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <!-- GRANULARITY -->
        @if (IhasGranularity) {
          <div class="cubejs-form-block">
            <span class="cubejs-form-block-label">{{'timeGroup.by' | translate}}</span>
            <mat-form-field appearance="fill" class="cubejs-dropdown">
              <mat-select [(value)]="currentGranularity" (selectionChange)="onChangeGranularity($event.value)">
                @for (granularity of granularityList; track granularity) {
                  <mat-option [value]="granularity.value">
                    {{granularity.name | translate}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (!IhasGranularity) {
          <div class="cubejs-form-block empty">&nbsp;</div>
        }
        <!-- ITEMISATION -->
        @for (filter of Iitemisation; track filter) {
          <div class="cubejs-form-block">
            <span class="cubejs-form-block-label">{{filter.label | translate}}</span>
            <mat-form-field appearance="fill" class="cubejs-dropdown">
              <mat-select [(value)]="filter.current" (selectionChange)="onChangeItemisation($event.value, filter.member, filter.operator, filter.type)">
                @for (item of filter.values; track item) {
                  <mat-option [value]="item.value">
                    {{item.name | translate}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
        @if (!Iitemisation.active) {
          <div class="cubejs-form-block empty">&nbsp;</div>
        }
      </div>
      <!-- error -->
      @if (hasError) {
        <div class="station-dashboard-error alert-danger">{{ 'graphStation.errorMsg' | translate }}</div>
      } @else {
        <app-query-renderer [chartType]="chartType.asObservable()"
          [cubeQuery]="cubeQuery.asObservable()"
          [pivotConfig]="pivotConfig.asObservable()"
          [unit]="unit.asObservable()"
          [graphType]="graphType.asObservable()"
          [convertValue]="convertValue"
          [clickable]="clickable"
          (hasError)="onHasError($event)"
          (clicked)="transferEvent($event)"
        ></app-query-renderer>
      }
      <!-- GRAPH -->
    </div>
  </div>
}
